import {w} from './cltvo/constants';
export const previsualizador_movil = function () {
	/* P R E V I S U A L I Z A D O R */

    gsap.registerPlugin(ScrollTrigger);
    const prev_tl = gsap.timeline();

    $(document).ready(function() { 

        if(  $('#application__col').length ){
            console.log('Hay previsualizador');

            const targetNode = document.getElementById('application__col');
            const config = { attributes: true, childList: true, subtree: true };
            let height_aux;

            let triggers = ScrollTrigger.getAll();
                    triggers.forEach( trigger => {			
                        trigger.kill(true);
                    });

            const callback = (mutationList, observer) => {
                for (const mutation of mutationList) {
                    if (mutation.type === 'childList') {
                        height_aux = $('#application__col').innerHeight();
                        document.documentElement.style.setProperty('--pad-aux', `${height_aux}px`);
                        sticky_prev($('#application_trigger'));
                        observer.disconnect();
                    } else if (mutation.type === 'attributes') {
                        sticky_prev($('#application_trigger'));
                        observer.disconnect();
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }
    });

    const sticky_prev = ( obj ) =>{
        ScrollTrigger.refresh(true);
        prev_tl.to(obj, {
            scrollTrigger : {
                trigger: obj,
                start: 'start start+=100',
                end: 'bottom end',
                markers: false,
                refreshPriority: 1,
                onEnter: () => {
                    $('#application_shadow').addClass('active');
                    $('#application__col').addClass('available');
                    $('#application_trigger_prev').addClass('available');
                    $('#share_label').css('display', 'none');
                },
                onLeave: () => {
                    $('#application_shadow').removeClass('active');
                    $('#application__col').removeClass('available');
                    $('#application_trigger_prev').removeClass('available');
                    $('#share_label').css('display', 'block');
                },
                onEnterBack: () => {
                    $('#application_shadow').addClass('active');
                    $('#application__col').addClass('available');
                    $('#application_trigger_prev').addClass('available');
                    $('#share_label').css('display', 'none');
                },
                onLeaveBack: () => {
                    $('#application_shadow').removeClass('active');
                    $('#application__col').removeClass('available');
                    $('#application_trigger_prev').removeClass('available');
                    $('#share_label').css('display', 'block');
                },
            }
        })
    }

    $('#application_trigger_prev').click(function(){
        $(this).toggleClass('active');
        $('#application__col').toggleClass('active');
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/previsualizador.js